import { useState } from 'react';
import Image from '@plone/volto/components/theme/Image/Image';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import {
  BackToTop,
  LogoGovbr,
  MenuLink,
  SocialLinks,
} from 'govbr.frontend.policy/components';
import footerMessages from 'govbr.frontend.policy/messages/footer';
import {
  CookieBanner,
  ManageCookiesButton,
} from 'govbr.lgpd.plugin/components';
import { defineMessages, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

import styles from './Footer.module.less';

const messages = defineMessages({
  socialNetworks: {
    id: 'Social networks',
    defaultMessage: 'Social networks',
  },
  siteMap: {
    id: 'Site map',
    defaultMessage: 'Site map',
  },
});

const FooterItem = ({ item, lang }) => {
  const { items = [] } = item;

  const [active, setActive] = useState(false);

  return (
    <div className="mb-1 mb-md-6">
      <MenuLink
        className={`br-item header d-none d-md-flex`}
        href={item.url}
        lang={lang}
      >
        <div className="content text-base text-bold text-uppercase">
          {item.title}
        </div>
      </MenuLink>

      <MenuLink
        className={`br-item header d-md-none`}
        href={item.url}
        onClick={
          items.length
            ? (e) => {
                e.preventDefault();
                setActive(!active);
              }
            : null
        }
        lang={lang}
      >
        <div className="content text-base text-semi-bold text-uppercase">
          {item.title}
        </div>

        {!!items.length && (
          <div className="support">
            <i className="fas fa-angle-down" aria-hidden="true" />
          </div>
        )}
      </MenuLink>

      {!!items.length && (
        <div className={`br-list ${active ? 'd-block' : 'd-none'} d-md-block`}>
          <span className="br-divider d-md-none" />
          {items.map((i) => (
            <MenuLink
              href={i.url}
              key={i.url || '/'}
              className={`br-item`}
              lang={lang}
            >
              <div className="content">{i.title}</div>
            </MenuLink>
          ))}
          <span className="br-divider d-md-none"></span>
        </div>
      )}
    </div>
  );
};

const Footer = (props) => {
  const { intl } = props;

  // const { settings } = config;
  // const token = useSelector((state) => state.userSession.token);
  const items = useSelector((state) => state.navigation.items);
  const lang = useSelector((state) => state.intl.locale);
  const content = useSelector((state) => state.content?.data);

  // const dispatch = useDispatch();

  // useEffect(() => {
  //   if (!hasApiExpander('navigation', getBaseUrl(pathname))) {
  //     dispatch(getNavigation(getBaseUrl(pathname), settings.navDepth));
  //   }
  // }, [dispatch, token, pathname, getNavigation, settings.footerNavDepth]);

  return (
    <div>
      <SlotRenderer name="aboveFooter" content={content} />
      <footer id="footer" className={`br-footer ${styles.footer}`}>
        <div className="ui container">
          <div className="logo">
            <LogoGovbr
              invert
              className={styles.svg}
              title="Portal Gov.br"
              title-id="footer-logo-title"
            />
          </div>
          <nav aria-label={intl.formatMessage(messages.siteMap)}>
            <ResponsiveMasonry
              sequential
              columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1000: 4 }}
              gutterBreakPoints={{ 350: '12px', 750: '16px', 900: '24px' }}
            >
              <Masonry>
                {items.map((item, index) => (
                  <FooterItem
                    item={item}
                    key={`${item.url || '/'}-${index}`}
                    lang={lang}
                  />
                ))}
              </Masonry>
            </ResponsiveMasonry>
          </nav>
          <div className="pt-5">
            <ManageCookiesButton
              className="br-button dark-mode"
              label={intl.formatMessage(footerMessages.resetCookies)}
            />
          </div>

          <div className="d-none d-sm-block">
            <div className="row align-items-end justify-content-between py-5">
              <div className="col social-network">
                <SocialLinks
                  labelClassName="text-up-01 text-extra-bold text-uppercase"
                  label={intl.formatMessage(messages.socialNetworks)}
                />
              </div>
              <div className="col assigns text-right">
                <a
                  className="d-inline-block ml-4"
                  href="https://www.gov.br/acessoainformacao"
                  rel="noreferrer"
                >
                  <Image
                    src="/logo-acesso-info.png"
                    alt="Acesso à informação"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <span className="br-divider my-3"></span>
        <div className="container-lg">
          <div className="info">
            <div className="text-down-01 text-medium pb-3">
              {intl.formatMessage(footerMessages.copyright, {
                license: (
                  <a
                    key="copyright-license"
                    className="item"
                    href="https://creativecommons.org/licenses/by-nd/3.0/deed.pt_BR"
                  >
                    {intl.formatMessage(footerMessages.license)}
                  </a>
                ),
              })}
            </div>
          </div>
        </div>
        <BackToTop alt="Voltar ao topo" />
      </footer>
      <CookieBanner />
    </div>
  );
};

Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
